import { Component, Inject, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DIALOG_DATA, DialogRef } from '@shared/component.dialog';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Button, ErrorModal } from './error-modal.interface';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [NgClass, TranslatePipe],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent implements OnInit {
  @Output() resetEvent = new EventEmitter<void>();
  buttons: Button[] = [];

  constructor(
    @Inject(DIALOG_DATA) public data: ErrorModal,
    private readonly dialogRef: DialogRef,
    private readonly router: Router
  ) { }


  ngOnInit(): void {
    this.handleConcatButton();
  }

  onClickClose() {
    this.dialogRef.close();
  }

  handleConcatButton() {
    this.buttons = [this.data.firstButton, this.data.secondButton];
  }

  onClickButton(url: string) {
    if (url !== '') {
      if (url.startsWith('https://')) {
        window.open(url);
        return;
      }
      this.router.navigate([url]);
      return;
    }
    this.resetEvent.emit();
    this.dialogRef.close();
  }
}
